export default {
  'not-found': 'Page introuvable',
  'internal-error': 'Impossible de traiter cette demande',
  'preview-error':
    "<strong>Le slug de l'article n'est pas valide</strong>.<br/> Vérifiez que le champ slug est rempli et que l'article a été <strong>Publié</strong> ou <strong>enregistré comme Brouillon</strong>.",
  continue: 'Continuer à naviguer',
  'no-search-results': 'Nessun risultato trovato',
  'back-to-home': 'Torna in home',
}
